import { Component, OnInit } from '@angular/core';
import { CdsIconModule } from '@cds/ng-web-components/icon';
import { CdsLanguageModule } from '@cds/ng-core/lang';

@Component({
  selector: 'app-split-agent-notification-info-error',
  templateUrl: './split-agent-notification-info-error.component.html',
  styleUrls: ['./split-agent-notification-info-error.component.scss'],
  imports: [CdsIconModule, CdsLanguageModule],
})
export class SplitAgentNotificationInfoErrorComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
